/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_DescriptionInputs */

const fr_admin_subscription_rights_description = /** @type {(inputs: Admin_Subscription_Rights_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palier, quota et option du membre, sans passer par Stripe.`)
};

/**

* @param {Admin_Subscription_Rights_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_description = /** @type {((inputs?: Admin_Subscription_Rights_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_description(inputs)
});